import CustomComponent from '../CustomComponent';

export const CAROUSEL_PAGINATION_RESET_EVENT = 'lta-carousel-pagination-reset';

const VARIANTS = {
	'media-carousel': {
		controls: 'lta-media-carousel__controls',
		prev: 'lta-media-carousel__prev',
		next: 'lta-media-carousel__next',
		pagination: 'swiper-pagination'
	},
	'carousel-v2': {
		controls: 'lta-carouselv2__controls',
		prev: 'lta-carouselv2__prev',
		next: 'lta-carouselv2__next',
		pagination: 'lta-carouselv2__pagination'
	}
};

export class CarouselPaginationComponent extends CustomComponent {
	static key = 'lta-carousel-pagination';

	static get observedAttributes() {
		return [
			'variant',
			'classes',
			'prev-icon',
			'next-icon',
			'prev-icon-classes',
			'next-icon-classes',
			'color',
			'hover-color',
			'active-color'
		];
	}

	_renderIcon(spriteIcon, classes = '') {
		const classNames = ['lta-icon', 'js-lta-text-input--btn-icon', classes].filter(Boolean).join(' ');

		return `
			<svg
				class="${classNames}"
				width="2rem"
				height="2rem"
				style="color:currentColor;"
				fill="currentColor"
				alt="${spriteIcon}"
				aria-hidden="true">
				<use xlink:href="/static/images/icons/lta-icons.svg#${spriteIcon}"></use>
			</svg>
		`;
	}

	render() {
		const {
			variant = 'media-carousel',
			classes = '',
			prevIcon = 'arrow-left-circle-tf',
			nextIcon = 'arrow-right-circle-tf',
			prevIconClasses = '',
			nextIconClasses = '',
			color,
			hoverColor,
			activeColor
		} = this.props;

		const config = VARIANTS[variant] || VARIANTS['media-carousel'];
		const styleParts = [];

		if (color) {
			styleParts.push(`--lta-carousel-pagination-color: ${color}`);
		}

		if (hoverColor) {
			styleParts.push(`--lta-carousel-pagination-hover-color: ${hoverColor}`);
		}

		if (activeColor) {
			styleParts.push(`--lta-carousel-pagination-active-color: ${activeColor}`);
		}

		const styleAttr = styleParts.length ? ` style="${styleParts.join('; ')}"` : '';

		return `
			<div class="${config.controls} lta-carousel-pagination ${classes}"${styleAttr}>
				<button class="${config.prev} u-mr-2" type="button" aria-label="Previous slide">
					${this._renderIcon(prevIcon, prevIconClasses)}
				</button>
				<div class="${config.pagination} u-hstack u-gap-1"></div>
				<button class="${config.next} u-ml-2" type="button" aria-label="Next slide">
					${this._renderIcon(nextIcon, nextIconClasses)}
				</button>
			</div>
		`;
	}

	afterRender() {
		this._emitResetEvent();
	}

	_emitResetEvent() {
		this.dispatchEvent(new CustomEvent(CAROUSEL_PAGINATION_RESET_EVENT, {
			bubbles: true,
			detail: {
				variant: this.props.variant || 'media-carousel',
				attributeNames: CarouselPaginationComponent.observedAttributes.filter(
					(attr) => this.hasAttribute(attr)
				)
			}
		}));
	}
}

export default CarouselPaginationComponent;
